/*@ngInject*/
const MultiSelectClassCodeController = function ($rootScope, $scope, $q, $timeout, localization, xmlUtil, formMediator, coreConstant, uuidUtil) {

    this.promptValue = '';
    this.filterTextPrompt = '';
    this.itemName = `Multi Select Class Code ${uuidUtil.generateUUID()}`;

    this.$onInit = function () {
        this.dropdownSelectedValue = null;

        localization.getTranslationByKey('formsViewer.controls.multiSelectClassCode').then((translations) => {
            this.promptValue = _.get(translations, 'selectClassCodePrompt');

            this.fieldOptions = this.fieldStructure.uiField.options ? xmlUtil.parseString(this.fieldStructure.uiField.options) : {};
            this.classCodeType = this.fieldOptions.classCodeType || 'NCCI';

            let classCodeValue = '',
                classCodeArr = [],
                items = [];
            if (!_.isEmpty(this.fieldStructure.fieldModel.value)) {
                classCodeValue = this.fieldStructure.fieldModel.value;
                classCodeArr = classCodeValue.split(',');
            }

            const promiseList = [];
            _.each(classCodeArr, (classCode) => {
                classCode = _.trim(_.trim(classCode), '::');

                promiseList.push(formMediator.getClassCodeItemsNoDate(this.classCodeType, classCode));
            });

            $q.all(promiseList).then((classCodeItems) => {
                _.each(_.cloneDeep(classCodeItems), function (item) {
                    if (item.length > 0) {
                        item[0].selected = true;
                        items.push(item[0]);
                    }
                });
                //Added this timeout, just to make avoid $broadcast firing before the $on is ready
                $timeout(() => $rootScope.$broadcast(coreConstant.event.MULTI_SELECT_LIST_UPDATED, this.itemName, items));
                this.filterToolTip(items);
            });

            formMediator.getClassCodeFormat(this.classCodeType).then((format) => {
                this.isStateClassCode = format.indexOf('{state}') !== -1;

                if (this.isStateClassCode) {
                    this.minimumSearchCharacters = parseInt(_.get(translations, 'stateClassCodeMinimumSearchCharacters'));
                } else {
                    this.minimumSearchCharacters = parseInt(_.get(translations, 'classCodeMinimumSearchCharacters'));
                }

                if (this.minimumSearchCharacters === 1) {
                    this.filterTextPrompt = _.get(translations, 'filterTextPromptSingular');
                } else {
                    this.filterTextPrompt = _.replace(_.get(translations, 'filterTextPromptPlural'), '{minimumSearchCharacters}', this.minimumSearchCharacters);
                }
            });
        });
    };

    this.filterToolTip = function (items) {
        let tooltipArr = _.map(items, function (item) {
            return item.description;
        });
        let toolTipValue = _.replace(tooltipArr.toString(), new RegExp(',', 'g'), ', ');
        this.fieldStructure.dynamicProperties.tooltip = {
            type: '',
            message: toolTipValue
        };
    };

    this.handleMultiSelectClassCodeChange = function (selectedValueList) {
        let selectedClassCodeValue = _.map(selectedValueList, function (selectedValue) {
            return selectedValue.code + '::';
        });
        selectedClassCodeValue = _.join(selectedClassCodeValue, ',');

        if (!_.isNil(selectedClassCodeValue)) {
            this.filterToolTip(selectedValueList);
            this.fieldStructure.fieldModel.value = selectedClassCodeValue;
        } else {
            this.fieldStructure.fieldModel.value = '';
            this.fieldStructure.dynamicProperties.tooltip = {
                type: '',
                messages: ''
            };
        }
        this.onSelect({classCodeValue: this.fieldStructure.fieldModel.value});
    };

    $scope.$on(coreConstant.event.MULTI_SELECT_CLEAR, (event, itemName) => {
        if (this.itemName === itemName) {
            this.fieldStructure.dynamicProperties.tooltip.message = '';
        }
    });

    $scope.$on(coreConstant.event.MULTI_SELECT_FILTER_CHANGED, (event, itemName, searchText) => {
        if (this.itemName === itemName) {
            if (_.size(searchText) >= this.minimumSearchCharacters) {
                formMediator.getClassCodeItemsNoDate(this.classCodeType, searchText).then((result) => {
                    this.itemList = _.cloneDeep(result);
                    $rootScope.$broadcast(coreConstant.event.MULTI_SELECT_LIST_UPDATED, this.itemName, this.itemList, searchText);
                });
            } else {
                this.itemList = [];
                $rootScope.$broadcast(coreConstant.event.MULTI_SELECT_LIST_UPDATED, this.itemName, this.itemList, searchText);
            }
        }
    });

    $scope.$on(coreConstant.event.RELOAD_CLASS_CODE_MULTI_SELECT, () => {
        this.fieldStructure.fieldModel.value = null;

        this.$onInit();
    });
};

angular.module('umFormViewer')
    .controller('multiSelectClassCodeController', MultiSelectClassCodeController);
